<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="event && event.id">{{ 'EVENTS.EVENTS_FORM.EDIT' | translate }}</span>
    <span *ngIf="!event || !event.id">{{ 'EVENTS.EVENTS_FORM.ADD' | translate }}</span>
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
  </button>
</div>

<ng-scrollbar class="modal-body ps">
  <form id="event-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label>{{ 'EVENTS.EVENTS_FORM.TYPE' | translate }}</label>
              <app-type-select
                [parentFormGroup]="form"
                [groupType]="'event'"
                [passFormControlName]="'type_id'"
                [bindValue]="'id'"
              ></app-type-select>
            </div>
          </div>

          <div class="col-sm-6" [hidden]="form.get('type_id').value === EventType.BUSINESS_TRIP">
            <div class="form-group relative">
              <app-event-group-select
                [parentFormGroup]="form"
                [includes]="'industry,venue'"
                (change)="eventGroupChange($event)"
              >
              </app-event-group-select>
              <div class="fill-from-group" *ngIf="eventForFill">
                <span class="btn btn-link pointer p-0" (click)="patchFromEventGroup()">
                  {{ 'EVENTS.EVENTS_FORM.FILL_FROM_GROUP' | translate }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-sm-6" [hidden]="form.get('type_id').value === EventType.BUSINESS_TRIP">
            <div class="form-group">
              <label>{{ 'EVENTS.EVENTS_FORM.ORGANIZER' | translate }}</label>
              <input type="text" class="form-control" formControlName="organizer" />
            </div>
          </div>

          <div class="col-sm-6" [hidden]="form.get('type_id').value === EventType.BUSINESS_TRIP">
            <div class="form-group">
              <label>{{ 'EVENTS.EVENTS_FORM.VISITORS' | translate }}</label>
              <input type="number" class="form-control" formControlName="visitors" />
            </div>
          </div>

          <div class="col-sm-6" [hidden]="form.get('type_id').value === EventType.BUSINESS_TRIP">
            <div class="form-group">
              <label>{{ 'EVENTS.EVENTS_FORM.EXHIBITORS' | translate }}</label>
              <input type="number" class="form-control" formControlName="exhibitors" />
            </div>
          </div>

          <div class="col-sm-6" [hidden]="form.get('type_id').value === EventType.BUSINESS_TRIP">
            <div class="form-group">
              <label>{{ 'EVENTS.EVENTS_FORM.INDUSTRY' | translate }}</label>
              <app-industry-select #industrySelectComponent [parentFormGroup]="form"></app-industry-select>
            </div>
          </div>

          <div class="col-sm-6" [hidden]="form.get('type_id').value === EventType.BUSINESS_TRIP">
            <div class="form-group">
              <label>{{ 'EVENTS.EVENTS_FORM.LINK_EXHIBITORS' | translate }}</label>
              <input type="text" class="form-control" formControlName="link_exhibitors" />
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label>{{ 'EVENTS.EVENTS_FORM.VENUE' | translate }}</label>
              <app-venue-select #venueSelectComponent [parentFormGroup]="form" [passFormControlName]="'venue_id'">
              </app-venue-select>
            </div>
          </div>

          <div class="col-sm-6" [hidden]="form.get('type_id').value === EventType.EVENT">
            <app-cities-select [parentFormGroup]="form"></app-cities-select>
          </div>

          <div class="col-sm-6" [hidden]="form.get('type_id').value === EventType.BUSINESS_TRIP">
            <div class="form-group">
              <label>{{ 'EVENTS.EVENTS_FORM.WEBSITE_URL' | translate }}</label>
              <input type="text" class="form-control" formControlName="website_url" />
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label>{{ 'EVENTS.EVENTS_FORM.PRIORITY' | translate }}</label>
              <app-type-select
                [parentFormGroup]="form"
                [passFormControlName]="'priority_id'"
                [groupType]="'event_group_priorities'"
              ></app-type-select>
            </div>
          </div>

          <div class="col-sm-12">
            <app-tags-select [parentFormGroup]="form" [model]="LaravelModelsEnum.EVENT"></app-tags-select>
          </div>

          <!-- clearfix-->
          <div class="col-sm-12"></div>

          <div class="col-sm-6">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" formControlName="active" id="event-form-active" />
              <label class="custom-control-label" for="event-form-active">{{
                'EVENTS.EVENTS_FORM.ACTIVE' | translate
              }}</label>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                formControlName="show_to_web"
                id="event-form-show-to-web"
              />
              <label class="custom-control-label" for="event-form-show-to-web">{{
                'EVENTS.EVENTS_FORM.SHOW_TO_WEB' | translate
              }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <label>{{ 'EVENTS.EVENTS_FORM.NAME' | translate }}</label>
              <input type="text" class="form-control" formControlName="name" />
            </div>
          </div>
           <div class="col-sm-6">
            <div class="form-group">
              <label>{{ 'EVENTS.EVENTS_FORM.DATE_FROM' | translate }}</label>
              <app-date-picker #dateFromPicker [FormControl]="form.get('date_from')"></app-date-picker>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label>{{ 'EVENTS.EVENTS_FORM.DATE_TO' | translate }}</label>
              <app-date-picker
                #dateToPicker
                [FormControl]="form.get('date_to')"
                [minDate]="form.get('date_from')?.value || null"
              ></app-date-picker>
            </div>
          </div>

          <div class="col-sm-6" [hidden]="form.get('type_id').value === EventType.BUSINESS_TRIP">
            <div class="form-group">
              <label>{{ 'EVENTS.EVENTS_FORM.FOREIGN_EXHIBITORS' | translate }}</label>
              <input type="number" class="form-control" formControlName="foreign_exhibitors" />
            </div>
          </div>

          <div class="col-sm-6" [hidden]="form.get('type_id').value === EventType.BUSINESS_TRIP">
            <div class="form-group">
              <label>{{ 'EVENTS.EVENTS_FORM.YEAR_EXHIBITORS' | translate }}</label>
              <input type="number" class="form-control" formControlName="year_exhibitors" />
            </div>
          </div>

          <div class="col-sm-12">
            <div class="form-group">
              <label>{{ 'EVENTS.EVENTS_FORM.NOTE' | translate }}</label>
              <textarea
                class="form-control note-textarea"
                formControlName="note"
                [rows]="3"
                [cols]="30"
                pInputTextarea
                autoResize="true"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-scrollbar>

<div class="modal-footer d-flex justify-content-between">
  <div>
    <app-links-compact-translates [data]="event" *ngIf="event && event.id"></app-links-compact-translates>
  </div>

  <div>
    <button type="submit" class="btn btn-outline-dark btn-xs" form="event-form" [disabled]="form.invalid">
      {{ 'EVENTS.EVENTS_FORM.SAVE' | translate }}
    </button>
  </div>
</div>
